import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';
import CommonOlList from '../../../common-components/common-ol-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const devRecList = {
    colorNumber: '#3A74B7',
    big: true,
    list: [
        'Круглосуточная техническая поддержка сайта и&nbsp;внутреннего портала;',
        'Доработки имеющегося функционала, модернизация сайта и&nbsp;портала.',
    ],
};

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="dev-rec-task" bigPaddings={true}>
                <div className="dev-rec-task__wrapper">
                    <CommonUsualText className="dev-rec-task__info">
                        <CommonTitle>Задачи</CommonTitle>
                    </CommonUsualText>
                    <CommonOlList className="dev-rec-task__list" CommonOlList={devRecList} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
